import { render } from "./percentage-card.vue?vue&type=template&id=55370033&ts=true"
import script from "./percentage-card.vue?vue&type=script&lang=ts"
export * from "./percentage-card.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__